// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__37ZQA","col":"styles_col__3kk6T"};